module.exports = __webpack_public_path__ + "img/ibo_logo.f808fba6.png";